module.exports = __webpack_public_path__ + "static/media/20130613_838018_933669.2f0c26c0.mp3";